import React, { useState, useEffect } from "react";
import axios from "axios";
import { SETTINGS_CRUD_API } from "../../hooks/APIHooks";

const Disclaimer = () => {
  const [companyData, setCompanyData] = useState({
    id: "",
    companylogo: "",
    companyName: "",
    companyTagLine: null,
    companyPhone: "",
    companyPhone2: "",
    companyEmail: "",
    companyWebsite: "",
    companyWhatsapp: "",
    companyAddress: "",
    GSTnumber: "",
    Tax: "",
    invoice_number: ""
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCompanySettings();
  }, []);

  const fetchCompanySettings = async () => {
    try {
      const response = await axios.get(SETTINGS_CRUD_API);
      if (response.data && !response.data.error) {
        setCompanyData(response.data);
      }
    } catch (err) {
      console.error("Error fetching company settings:", err);
      setError("Failed to load company information");
    } finally {
      setLoading(false);
    }
  };

  // Get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    const now = new Date();
    return now.toISOString().split('T')[0];
  };

  if (loading) {
    return (
      <section className="px-5 my-10">
        <div className="max-w-4xl mx-auto bg-white">
          <div className="text-center py-10">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
            <p className="mt-2 text-gray-600">Loading policy...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="px-5 my-10">
      <div className="max-w-4xl mx-auto bg-white">
        <h1 className="text-center text-2xl py-10 font-bold">
          Cancellation & Refund Policy
        </h1>
        
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded text-sm">
            {error}
          </div>
        )}
        
        Last updated: {getCurrentDate()}
        <br />
        <br />
        <p className="text-lg font-medium">
          {companyData.companyName} believes in helping its customers as
          far as possible, and has therefore a liberal cancellation policy.
          Under this policy:
        </p>
        <br />
        <ul className="list-disc pl-5 space-y-2">
          <li className="py-2">
            Cancellations will be considered only if the request is made
            immediately after placing the order. However, the cancellation request
            may not be entertained if the orders have been communicated to the
            vendors/merchants and they have initiated the process of shipping
            them.
          </li>
          <li className="py-2">
            {companyData.companyName} does not accept cancellation and
            Refund.
          </li>
          <li className="py-2">
            In case of receipt of damaged or defective items, please report it to our customer service within 24 hours of receipt.
          </li>
          <li className="py-2">
            For any queries related to cancellation and refund, please contact us at {companyData.companyEmail || "our customer service"}.
          </li>
        </ul>
        
        {/* Additional Policy Sections */}
        <div className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Refund Process</h2>
          <p className="text-gray-700 mb-4">
            If a refund is approved, it will be processed within 7-10 business days. The amount will be refunded to the original payment method used during the purchase.
          </p>
        </div>
        
        <div className="mt-6">
          <h2 className="text-xl font-semibold mb-4">Contact Information</h2>
          <p className="text-gray-700">
            For any questions about this Cancellation & Refund Policy, please contact us:
          </p>
          <div className="mt-2 text-gray-700">
            {companyData.companyEmail && (
              <p>Email: {companyData.companyEmail}</p>
            )}
            {companyData.companyPhone && (
              <p>Phone: {companyData.companyPhone}</p>
            )}
            {companyData.companyPhone2 && (
              <p>Alternate Phone: {companyData.companyPhone2}</p>
            )}
            {companyData.companyAddress && (
              <p>Address: {companyData.companyAddress}</p>
            )}
            {companyData.GSTnumber && (
              <p>GST Number: {companyData.GSTnumber}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;